import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import EmptyState from '../EmptyState';
import DecisionCard from './DecisionCard';

const SECTIONS = [
  { type: 'new', title: 'New rules', color: '#34d399', bg: 'rgba(16, 185, 129, 0.15)' },
  { type: 'extend', title: 'Extended rules', color: '#60a5fa', bg: 'rgba(59, 130, 246, 0.15)' },
  { type: 'merge', title: 'Merged rules', color: '#c084fc', bg: 'rgba(168, 85, 247, 0.15)' },
];

function DayDecisionList({ decisions = [] }) {
  if (decisions.length === 0) {
    return <EmptyState message="No decisions this day" description="This day had no rule-synthesis decisions." />;
  }

  const grouped = SECTIONS.map((section) => ({
    ...section,
    items: decisions.filter((d) => (d.type || '').toLowerCase() === section.type),
  })).filter((section) => section.items.length > 0);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
      {grouped.map((section) => (
        <Box key={section.type}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#e2e8f0' }}>
              {section.title}
            </Typography>
            <Chip
              label={section.items.length}
              size="small"
              sx={{
                height: 20,
                fontSize: '0.68rem',
                fontWeight: 700,
                color: section.color,
                background: section.bg,
                border: `1px solid ${section.color}40`,
              }}
            />
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            {section.items.map((decision, idx) => (
              <DecisionCard key={`${decision.type}-${decision.rule.id}-${idx}`} decision={decision} />
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  );
}

export default DayDecisionList;
